import { render, staticRenderFns } from "./AboutNuoyou.vue?vue&type=template&id=11f4266a&scoped=true&"
import script from "./AboutNuoyou.vue?vue&type=script&lang=js&"
export * from "./AboutNuoyou.vue?vue&type=script&lang=js&"
import style0 from "./AboutNuoyou.vue?vue&type=style&index=0&id=11f4266a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f4266a",
  null
  
)

export default component.exports